/*                                     */
import type { Unsubscriber } from "svelte/store";
import type { ActionReturn } from "svelte/action";
import { safeId } from "@otto-ec/otto-components-utils/utils/safeId";
import { componentsScope } from "../../../../common/utils/logger.js";
import type { Props } from "../SheetV1.types.js";

export const sheetScope = /*           */ componentsScope.scope("sheet-v1");

export const sheetProps = [
  "id",
  "url",
  "base64Url",
  "open",
  "allowedErrorStatusCodes",
  "extraData",
  "headline",
  "headlineLevel",
  "hideHeader",
  "hideCloseButton",
  "fullHeight",
  "ocAriaLabel",
  "noContentPadding",
  "discardContentOnInactive",
] as const satisfies (keyof Props)[];

/**
 *
 */
export const autoIdPrefix = "auto-";

/**
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function applyProps(sheet: HTMLOcSheetV1Element, config: Partial<Props>): string {
  Object.entries(config).forEach(([key, value]) => {
    /*                                                     */
    sheet[key] = value;
  });

  /*                             */
  sheet.id ??= safeId(undefined, autoIdPrefix);
  /*                                            */
  sheet.setAttribute("id", sheet.id);

  return sheet.id;
}

/**
 *
 *
 *
 *
 *
 */
export const onDestroy = (...unsubs: Unsubscriber[]): ActionReturn => ({
  destroy: () => unsubs.forEach((u) => u()),
});

export const unsetSheetDisplayNone = (element: HTMLElement): void => {
  element.style.display = "";
};

export const setSheetDisplayNone = (element: HTMLElement): void => {
  element.style.display = "none";
};
